export function cancellationInterceptor($provide, $httpProvider) {
  'ngInject';

  $provide.factory('cancellationInterceptor', ($q) => {
    'ngInject';
    return {
      responseError: (rejection) => {
        // Only swallow the error when the request was explicitly marked as
        // cancellable AND was actually aborted (status -1). Genuine network
        // failures on non-cancellable requests still propagate normally.
        if (rejection.status === -1 && rejection.config._cancellable) {
          return $q.resolve({ _cancelled: true });
        }
        return $q.reject(rejection);
      },
    };
  });

  $httpProvider.interceptors.push('cancellationInterceptor');
}
